/* joacă bună — căutare predictivă (drawer meniu, mobil). Shopify Predictive Search API
   (/search/suggest.json), debounce 250ms, minim 2 caractere, max 5 produse. Vanilla. */
(function () {
  'use strict';
  var form = document.querySelector('[data-predictive-search]');
  if (!form) return;
  var input = form.querySelector('[data-predictive-search-input]');
  var results = form.querySelector('[data-predictive-search-results]');
  var moneyFormat = form.dataset.moneyFormat || '{{amount}}';
  var debounceTimer = null;
  var requestId = 0;

  function formatMoney(cents) {
    var noDec = /no_decimals/.test(moneyFormat);
    var amount = (cents / 100).toLocaleString('ro-RO', { minimumFractionDigits: noDec ? 0 : 2, maximumFractionDigits: noDec ? 0 : 2 });
    if (/\{\{\s*amount/.test(moneyFormat)) return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    return amount + ' lei';
  }

  function thumbUrl(src) {
    if (!src) return '';
    return src.replace(/(\.[a-z]+)(\?.*)?$/i, '$1') + '?width=80';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function show(html) {
    results.innerHTML = html;
    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }
  function hide() {
    results.hidden = true;
    results.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
  }

  function renderLoading() {
    show('<p class="jb-predictive__status">Se caută…</p>');
  }
  function renderEmpty(query) {
    show('<p class="jb-predictive__status">Niciun rezultat pentru „' + escapeHtml(query) + '”.</p>');
  }
  function renderResults(products, query) {
    var items = products.map(function (p) {
      var price = formatMoney(Math.round(parseFloat(p.price_min) * 100));
      var thumb = thumbUrl(p.image);
      var media = thumb
        ? '<img class="jb-predictive__thumb" src="' + thumb + '" alt="" loading="lazy" width="40" height="40">'
        : '<span class="jb-predictive__thumb jb-predictive__thumb--empty" aria-hidden="true"></span>';
      return (
        '<li><a class="jb-predictive__item" href="' + escapeHtml(p.url) + '">' +
          media +
          '<span class="jb-predictive__info">' +
            '<span class="jb-predictive__title">' + escapeHtml(p.title) + '</span>' +
            '<span class="jb-predictive__price">' + price + '</span>' +
          '</span>' +
        '</a></li>'
      );
    }).join('');
    var viewAllUrl = form.getAttribute('action') + '?q=' + encodeURIComponent(query);
    show(
      '<ul class="jb-predictive__list" role="list">' + items + '</ul>' +
      '<a class="jb-predictive__viewall" href="' + escapeHtml(viewAllUrl) + '">Vezi toate rezultatele pentru „' + escapeHtml(query) + '”</a>'
    );
  }

  function search(query) {
    var id = ++requestId;
    renderLoading();
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (id !== requestId) return; // răspuns vechi — a apărut o căutare mai nouă
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) { renderEmpty(query); return; }
        renderResults(products, query);
      })
      .catch(function () { if (id === requestId) hide(); });
  }

  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    var query = input.value.trim();
    if (query.length < 2) { requestId++; hide(); return; }
    debounceTimer = setTimeout(function () { search(query); }, 250);
  });

  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) hide();
  });
})();
